import React, { useEffect, useState } from "react";
import PhoneInput from "react-phone-input-2";
import { useFormContext, Controller } from "react-hook-form";
import { IoIosEye, IoIosEyeOff, IoIosMail } from "react-icons/io";
import { preferredContactMethod } from "../../../constants";

import InputField from "../../../shared/components/input-field/InputField";
import ReactSelect from "../../../shared/components/ReactSelect/ReactSelect";
import CustomError from "../../../shared/components/custom-error/CustomError";

const AgentInformationForm = (props) => {
  const {
    isDisabled,
    allLanguages,
    selectedLanguage,
    setSelectedLanguage,
    selectedPreferredContactMethod,
    setSelectedPreferredContactMethod,
  } = props;

  const {
    formState: { errors },
    watch,
    setValue,
    setError,
    clearErrors,
  } = useFormContext();

  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [phoneLength, setPhoneLength] = useState(0);

  const getPasswordVisibilityIcon = (isPasswordVisible, toggleVisibility) => {
    return (
      <div className="position-absolute input-field-icon">
        {isPasswordVisible ? (
          <IoIosEye onClick={() => toggleVisibility(!isPasswordVisible)} />
        ) : (
          <IoIosEyeOff onClick={() => toggleVisibility(!isPasswordVisible)} />
        )}
      </div>
    );
  };

  useEffect(() => {
    if (watch("agent.phoneNumber")) {
      if (
        phoneLength > watch("agent.phoneNumber")?.length &&
        watch("agent.phoneNumber")?.length < 15
      ) {
        setError("agent.phoneNumber", {
          type: "minLength",
          message: "Invalid phone number",
        });
      } else {
        clearErrors("agent.phoneNumber");
      }
    }

    // eslint-disable-next-line
  }, [watch("agent.phoneNumber")]);

  return (
    <div className="agent-information">
      <div className="row">
        <div className="col-12 agent-information-heading">
          Agent Information
        </div>
        {/* full name input field */}
        <div className="col-12 col-lg-6 pe-xl-4">
          <div className="input-field-wrapper">
            <InputField
              name="agent.firstName"
              placeHolder="First Name"
              isDisabled={isDisabled}
            />
            <CustomError errorMessage={errors.agent?.firstName?.message} />
          </div>
        </div>
        {/* last name input field */}
        <div className="col-12 col-lg-6 ps-xl-4">
          <div className="input-field-wrapper">
            <InputField
              name="agent.lastName"
              placeHolder="Last Name"
              isDisabled={isDisabled}
            />
            <CustomError errorMessage={errors.agent?.lastName?.message} />
          </div>
        </div>
        {/* phone number input field */}
        <div className="col-12 col-lg-6 pe-xl-4">
          <div className="input-field-wrapper">
            <Controller
              name="agent.phoneNumber"
              placeHolder="(916) 687-9606"
              rules={{ required: true }}
              render={({ field: { ref, ...field } }) => (
                <PhoneInput
                  placeholder="(916) 687-9606"
                  {...field}
                  inputExtraProps={{
                    ref,
                    required: true,
                    autoFocus: true,
                  }}
                  onChange={(phone, country) => {
                    setValue("agent.phoneNumber", phone);
                    setPhoneLength(
                      country.format.split("").filter((char) => char === ".")
                        .length
                    );
                  }}
                  country={"us"} // Default country code
                  masks={{ sa: '.. ... ....' }}
                />
              )}
            />
            <CustomError errorMessage={errors.agent?.phoneNumber?.message} />
          </div>
        </div>
        {/* email input field */}
        <div className="col-12 col-lg-6 ps-xl-4">
          <div className="input-field-wrapper">
            <InputField
              type="email"
              name="agent.email"
              placeHolder="Email address"
              icon={
                <div className="position-absolute input-field-icon">
                  <IoIosMail />
                </div>
              }
              isDisabled={isDisabled}
            />
            <CustomError errorMessage={errors.agent?.email?.message} />
          </div>
        </div>
        {/* language spoken dropdown  */}
        <div className="col-12 col-lg-6 pe-xl-4">
          <div className="input-field-wrapper">
            <ReactSelect
              options={allLanguages}
              name="languageSpokenIds"
              placeholder="Language Spoken"
              isMulti
              selectedOption={selectedLanguage}
              setSelectedOption={setSelectedLanguage}
            />
            <CustomError
              errorMessage={errors.agent?.languageSpokenIds?.message}
            />
          </div>
        </div>
        {/* preferred contact method dropdown */}
        <div className="col-12 col-lg-6 ps-xl-4">
          <div className="input-field-wrapper">
            <ReactSelect
              options={preferredContactMethod}
              name="preferredContactMethodId"
              placeholder="Preferred Contact Method"
              selectedOption={selectedPreferredContactMethod}
              setSelectedOption={setSelectedPreferredContactMethod}
            />
            <CustomError
              errorMessage={errors.agent?.preferredContactMethodId?.message}
            />
          </div>
        </div>
        {/* create password input field */}
        <div className="col-12 col-lg-6 pe-xl-4">
          <div className="input-field-wrapper">
            <InputField
              name="agent.password"
              type={showPassword ? "text" : "password"}
              placeHolder="Create your password"
              icon={!isDisabled ? getPasswordVisibilityIcon(showPassword, setShowPassword) : undefined}
              isDisabled={isDisabled}
            />
            <CustomError errorMessage={errors.agent?.password?.message} />
          </div>
        </div>
        {/* confirm passowrd input field */}
        <div className="col-12 col-lg-6 ps-xl-4">
          <div className="input-field-wrapper">
            <InputField
              type={showConfirmPassword ? "text" : "password"}
              name="agent.confirmPassword"
              placeHolder="Confirm your password"
              icon={!isDisabled ? getPasswordVisibilityIcon(
                showConfirmPassword,
                setShowConfirmPassword
              ) : undefined}
              isDisabled={isDisabled}
            />
            <CustomError
              errorMessage={errors.agent?.confirmPassword?.message}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AgentInformationForm;
